var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { useWrapAsync, useAsyncEffect } from '@loop/comm-display-util-dom';
import { toFormInputs, buildDefaultIgnoreRulesViewState, mergeIgnoreRule, fromFormInputs } from './util';
import { validatedJsonPostHelpersFactory } from './api';
import { useAuthContext } from '../auth';
const useDlqIgnoreRulesForm = (defaultValues) => {
    const form = useForm({ defaultValues });
    const genericMatchersFieldArray = useFieldArray({ control: form.control, name: 'genericMatchers' });
    const modplanMatchersFieldArray = useFieldArray({ control: form.control, name: 'modplanMatchers' });
    for (const k of ['id', 'dlqName', 'env', 'region', 'description', 'ignoreRulesType']) {
        form.register(k, {
            required: 'is required',
        });
    }
    const selectedRuleType = form.watch('ignoreRulesType');
    return {
        form,
        genericMatchersFieldArray,
        modplanMatchersFieldArray,
        selectedRuleType,
    };
};
export const useDlqIgnoreRulesApi = (rulesType) => {
    var _a;
    const { error, resetAsync, wrapAsync } = useWrapAsync();
    const { authToken } = useAuthContext();
    if (!authToken) {
        throw new Error(`authToken is not set`);
    }
    const validatedJsonPostHelper = validatedJsonPostHelpersFactory(authToken, rulesType);
    const [state, setState] = useState(buildDefaultIgnoreRulesViewState());
    const form = useDlqIgnoreRulesForm(toFormInputs());
    const reset = () => {
        resetAsync();
    };
    useAsyncEffect(wrapAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        const { response: ignoreRules } = yield validatedJsonPostHelper.load({});
        const [selected] = ignoreRules;
        setState({
            ignoreRules,
            selected,
            view: 'SHOW',
        });
    })), []);
    useEffect(() => {
        var _a;
        if ((_a = state.selected) === null || _a === void 0 ? void 0 : _a.id) {
            form.form.reset(toFormInputs(state.selected));
        }
    }, [(_a = state.selected) === null || _a === void 0 ? void 0 : _a.id]);
    useEffect(() => {
        const matcherArrayToClear = form[form.selectedRuleType === 'MODPLAN' ? 'genericMatchersFieldArray' : 'modplanMatchersFieldArray'];
        matcherArrayToClear.fields.map((_, i) => matcherArrayToClear.remove(i));
        if (form.selectedRuleType === 'FARKEN-ERROR') {
            form.form.setValue('dlqName', 'FARKEN-ERRORS');
            form.genericMatchersFieldArray.fields
                .filter(({ key }) => key !== 'msg')
                .map((_, i) => matcherArrayToClear.remove(i));
        }
    }, [form.selectedRuleType]);
    return {
        error,
        state,
        form,
        actions: {
            setSelectedId: (selectedId) => {
                reset();
                const selected = state.ignoreRules.find(({ id }) => id === selectedId);
                if (!selected) {
                    throw new Error(`unknown ignoreRule: ${selectedId}`);
                }
                setState(Object.assign(Object.assign({}, state), { selected }));
            },
            newRule: () => {
                reset();
                setState(Object.assign(Object.assign({}, state), { view: 'NEW', info: undefined }));
                form.form.reset(toFormInputs());
            },
            cancel: () => {
                reset();
                const [selected] = state.ignoreRules;
                setState(Object.assign(Object.assign({}, state), { selected, view: 'SHOW' }));
            },
            updateRule: wrapAsync((data) => __awaiter(void 0, void 0, void 0, function* () {
                const dlqRuleRecord = fromFormInputs(data);
                yield validatedJsonPostHelper.upsert({ dlqRuleRecord });
                setState(Object.assign(Object.assign({}, state), { view: 'SHOW', ignoreRules: mergeIgnoreRule(state.ignoreRules, dlqRuleRecord), selected: dlqRuleRecord, info: `Rule saved: ${dlqRuleRecord.id}` }));
            })),
            deleteRule: wrapAsync((id) => __awaiter(void 0, void 0, void 0, function* () {
                yield validatedJsonPostHelper.delete({ id });
                const ignoreRules = state.ignoreRules.filter((ignoreRule) => ignoreRule.id !== id);
                const [selected] = ignoreRules;
                setState(Object.assign(Object.assign({}, state), { ignoreRules,
                    selected, info: `Rule deleted: ${id}` }));
            })),
        },
    };
};
//# sourceMappingURL=use-dlq-ignore-rules-api.js.map